export default __webpack_public_path__ + "static/media/uzh_logo.83a35217.svg";